import type { User } from "./types";

/**
 * True se l'utente può accedere a funzioni da docente (creazione contenuti, area riservata, ecc.):
 * super admin, ruolo di piattaforma admin, oppure associato ad almeno una scuola come admin o
 * insegnante (user_schools). NON conta il ruolo globale "teacher" (ogni account Google lo ha):
 * stessa regola di requireTeacherOrHigher nel collaboration-service (WP-10). Un account senza
 * scuole e' "in attesa".
 */
export function hasTeacherOrAboveAccess(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.is_super_admin) return true;

  const globalRole = (user.role || "").toLowerCase().replace(/-/g, "_");
  if (
    globalRole === "super_admin" ||
    globalRole === "superadmin" ||
    globalRole === "admin"
  ) {
    return true;
  }

  const schools = user.schools ?? [];
  return schools.some((s) => {
    const sr = (s.role || "").toLowerCase();
    return sr === "admin" || sr === "teacher";
  });
}
